module.exports = __webpack_public_path__ + "media/images/logodirect-8e776dffc6a8a63a73dbdddbc1b69e77.png";